import cn from 'classnames';
import { ReactNode } from 'react';

import styles from './BankCardContainer.module.scss';

interface BankCardContainerProps {
  children: ReactNode;
  className?: string;
}

export const BankCardContainer = ({ children, className }: BankCardContainerProps) => {
  return <div className={cn(styles.container, className)}>{children}</div>;
};
